import { render, staticRenderFns } from "./RankingsReport.vue?vue&type=template&id=1b401b74&"
import script from "./RankingsReport.vue?vue&type=script&lang=js&"
export * from "./RankingsReport.vue?vue&type=script&lang=js&"
import style0 from "./RankingsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports